/**
 * 勤怠区分
 */
export const AttendanceType = {
  ATTENDANCE: 1,  // 出勤
  ABSENCE: 2,     // 欠勤
  LATE_EARLY: 3,   // 遅刻・早退
} as const;

/**
 * 欠勤区分
 */
export const AbsenceType = {
  PAID_LEAVE: 1,    // 有給
  SPECIAL_LEAVE: 2, // 休暇
  ABSENCE: 3,       // 欠勤
} as const;

/**
 * 有給区分
 */
export const PaidLeaveType = {
  ALL_DAY: 1,   // 全日
  HALF_DAY: 2,  // 半日
} as const;
